/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TokubaiProjectCodeAndSalesStartDateRequest } from './TokubaiProjectCodeAndSalesStartDateRequest';
export type ChangeRequestDeleteApprovedRequest = {
    tokubaiProjectCodeAndSalesStartDateRequests?: Array<TokubaiProjectCodeAndSalesStartDateRequest>;
    changeRequestType?: ChangeRequestDeleteApprovedRequest.changeRequestType;
};
export namespace ChangeRequestDeleteApprovedRequest {
    export enum changeRequestType {
        COMPETITOR = 'COMPETITOR',
        FRESHNESS = 'FRESHNESS',
        INSTRUCTION = 'INSTRUCTION',
        FLYER = 'FLYER',
    }
}

